import React from 'react';

const mark = new URL('./mark.svg', import.meta.url).href;
const superAdminMark = new URL('./super-admin-mark.svg', import.meta.url).href;
const studentMark = new URL('./student-mark.svg', import.meta.url).href;
const studentWordmark = new URL('./student-wordmark.svg', import.meta.url).href;
const wordmark = new URL('./wordmark.svg', import.meta.url).href;
const whiteWordmark = new URL('./wordmark-white.svg', import.meta.url).href;
const sizes = { sm: [24, 96, 11], md: [32, 120, 12], lg: [48, 144, 14], xl: [64, 168, 14] };

/** One font-independent identity; the portal name remains context, never a different brand. */
export function BrandLogo({ size = 'md', showText = true, subtitle = '', textColor = 'default', className = '', variant = 'default' }) {
  const [icon, width, caption] = sizes[size] || sizes.md;
  const student = variant === 'student';
  const superAdmin = variant === 'super-admin';
  const white = textColor === 'white';
  return (
    <span data-brand-variant={variant} role="img" aria-label={`BayesPrep${subtitle ? ` ${subtitle}` : ''}`} className={className}
      style={{ display: 'inline-flex', alignItems: 'center', gap: size === 'sm' ? 8 : 12, maxWidth: '100%', verticalAlign: 'middle' }}>
      <img src={student ? studentMark : superAdmin ? superAdminMark : mark} alt="" aria-hidden="true" width={icon} height={icon} style={{ display: 'block', flexShrink: 0 }} />
      {showText && <span aria-hidden="true" style={{ display: 'flex', flexDirection: 'column', gap: 3, minWidth: 0 }}>
        <img src={white ? whiteWordmark : student ? studentWordmark : wordmark} alt="" width={width} height={Math.round(width * 78 / 400)}
          style={{ display: 'block', width, height: 'auto', maxWidth: '100%' }} />
        {subtitle && <span style={{ color: white ? '#FFFFFF' : student ? '#0456FF' : '#475569', fontFamily: 'Lato, sans-serif', fontSize: caption, lineHeight: 1.25, whiteSpace: 'nowrap', letterSpacing: student ? '0.06em' : undefined, textTransform: student ? 'uppercase' : undefined }}>{subtitle}</span>}
      </span>}
    </span>
  );
}
